import TextEditActions from "./TextEditActions";
import ColorCombination from "./ColorCombination";
import FontFamily from "./FontFamily";

export default {
  TextEditActions,
  ColorCombination,
  FontFamily,
};
